"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SogoHyoka = void 0;
var _CLabel = _interopRequireDefault(require("01_core/components/materials/CLabel"));
var _CSelect = _interopRequireDefault(require("01_core/components/materials/CSelect"));
var _CodeUtil = require("01_core/components/system/CodeUtil");
var _CodeConsts = require("01_core/constants/CodeConsts");
var _labelConsts = require("01_core/constants/labelConsts");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 総合評価
 */
const SogoHyoka = props => {
  const {
    intl,
    sogohyoka,
    onChange,
    getCodeItems,
    error,
    helperText
  } = props;
  return /*#__PURE__*/_react.default.createElement(_CLabel.default, {
    label: intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_RESULT_SOGO_HYOKA
    }),
    required: true
  }, /*#__PURE__*/_react.default.createElement(_CSelect.default, {
    items: getCodeItems(_CodeConsts.CODE.KANSA_SOGOHYOKA.KBN),
    value: sogohyoka,
    onChange: onChange,
    error: !!error,
    helperText: helperText
  }));
};
exports.SogoHyoka = SogoHyoka;
var _default = exports.default = (0, _CodeUtil.withCodeUtil)((0, _reactIntl.injectIntl)(SogoHyoka));